const intercept = {
  handleRequestParam(data) {
    const str = JSON.stringify(data).toLowerCase()
    const reg = /\b(select|update|and|or|<|>|[|]|delete|insert|trancate|char|into|substr|ascii|declare|exec|count|master|drop|execute)\b/g
    const res = str.match(reg)
    return res && res.length
  },
}
export { intercept }
